// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__-u9k6","item":"PaymentsMobile_item__1edb9","label":"PaymentsMobile_label__2SvQ7","amount":"PaymentsMobile_amount__1aQbL"};